import RouteDetailView from "pages/fsm/routes/[id]/RouteDetailView"
import React from "react"
import RouteAssignmentFooter from "./RouteAssignmentFooter"

const BeatMapView = ({ disabled = false }) => {
  return (
    <RouteDetailView
      showRouteInfo={false}
      className="h-[calc(100vh-48px-64px-180px)]"
      fetchData={false}
      disabled={disabled}
    >
      <RouteAssignmentFooter disabled={disabled} />
    </RouteDetailView>
  )
}

export default BeatMapView
